import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../dashboard.scss';
import CustomCountBox from '../../../../shared/custom-count-box/Custom-Count-Box';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
  dashboardFnbLoadingSelector,
  dashboardIrdCountSelector,
  fetchAllDashboardIrdList,
} from '../../../../layouts/home/DashboardSlice';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import { selectedHotelSelector } from '../../../../layouts/property/propertySlice';

const InRoomDiningTabDetail = (props) => {
  const dashboardIrdCount = useSelector(dashboardIrdCountSelector);
  const dashboardFnbLoading = useSelector(dashboardFnbLoadingSelector);
  const selectedHotel = useSelector(selectedHotelSelector);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllDashboardIrdList(selectedHotel));
  }, [selectedHotel, dispatch]);

  return dashboardFnbLoading ? (
    <div className='pt-4 col-md-12 pb-4'>
      <LinearProgressBar />
    </div>
  ) : (
    <>
      <div className='row'>
        <div className='col col-md-10'>In Room Dining</div>
      </div>
      {dashboardIrdCount?.length > 0 && (
        <div className='px-2'>
          <div className='py-2 d-flex flex-wrap gap-3'>
            {dashboardIrdCount?.map((currentCount, countNdx) => (
              <CustomCountBox count={currentCount} key={countNdx} className={'col'} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default InRoomDiningTabDetail;
